@switch (placement) {
  @case (LoadingIndicatorPlacement.Standalone) {
    <ng-container [ngTemplateOutlet]="indicator"/>
  }
  @case (LoadingIndicatorPlacement.TableRow) {
    <td colspan="100%" class="text-center">
      <ng-container [ngTemplateOutlet]="indicator"/>
    </td>
  }
  @case (LoadingIndicatorPlacement.Button) {
    @if (_isLoading) {
      <span class="spinner-border" [class.spinner-border-sm]="_useSmall" aria-hidden="true"></span>
      <span class="visually-hidden" role="status">{{ loadingText }}</span>
    } @else {
      <ng-content/>
    }
  }
}

<ng-template #indicator>
  <div class="spinner-border" [class]="colorClass()" [class.spinner-border-sm]="_useSmall" role="status">
    <span class="visually-hidden">{{ loadingText }}</span>
  </div>
</ng-template>
